import { Link } from 'react-router-dom';
import ROUTES from '../../routes/Routes.js';

export default function Unauthorized() {
    return (
        <>
            <div className="container mt-6">
                <div className="alert alert-danger mt-4 alert-dismissible fade show" role="alert">
                    <b>¡Acceso denegado!</b> <br />
                    No tienes permisos para esta página        
                </div>    
                <div style={{textAlign: "center"}}>
                    <Link to={ROUTES.HOME} className="btn btn-primary">Continuar</Link>
                </div>
            </div>
        </>
    );
}